import { render, staticRenderFns } from "./team-list.vue?vue&type=template&id=cfbd59da&scoped=true&"
import script from "./team-list.vue?vue&type=script&lang=js&"
export * from "./team-list.vue?vue&type=script&lang=js&"
import style0 from "./team-list.vue?vue&type=style&index=0&id=cfbd59da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbd59da",
  null
  
)

export default component.exports